// Textos del aviso cuando una promo se crea en varias cadenas y no todas salieron.
import { SAVE_ERROR_TITLE } from './salePromotionSaveError';

export const PARTIAL_CREATE_TITLE = 'La promo no se creó en todas las cadenas';

/** Sin ninguna creada, el motivo de la primera; con alguna, cuáles sí y cuáles no. */
export function perRetailerFailureCopy(
    createdNames: readonly string[],
    failed: readonly { name: string; reason: string }[],
): { title: string; description: string } {
    if (createdNames.length === 0)
        return { title: SAVE_ERROR_TITLE, description: failed[0].reason };
    const missing = failed.map((one) => `${one.name} (${one.reason})`).join(', ');
    return {
        title: PARTIAL_CREATE_TITLE,
        description: `Se creó en ${createdNames.join(', ')}. No se pudo en ${missing}. Guarda de nuevo para reintentar solo las que faltan.`,
    };
}

/** El nombre de la promo y, si salió en varias cadenas, en cuáles. */
export function perRetailerSuccessDescription(
    promoName: string,
    createdNames: readonly string[],
): string {
    return createdNames.length > 1 ? `${promoName} · ${createdNames.join(', ')}` : promoName;
}
